import {pluralize} from "@pg-mono/string-utils";
import {propertyOffer} from "@pg-mono/string-utils";

export enum PromotionType {
    PROMOTION = 1,
    OPEN_DAYS = 2,
    DISCOUNT = 3,
    LAST_MINUTE = 4,
    PRESALE = 5,
    EXHIBITION = 6,
    NO_CONTRIBUTION = 7
}

export const getPromotionTypeName = (type: PromotionType, offerLongVersion?: boolean): string => {
    switch (type) {
        case PromotionType.OPEN_DAYS:
            return "Dni Otwarte";
        case PromotionType.DISCOUNT:
            return "Przecena";
        case PromotionType.LAST_MINUTE:
            return "Last minute";
        case PromotionType.PRESALE:
            return "Przedsprzedaż";
        case PromotionType.EXHIBITION:
            return "Targi Mieszkaniowe";
        case PromotionType.NO_CONTRIBUTION:
            return `Nieruchomość bez wkładu własnego`;
        default:
            //  Offer
            return offerLongVersion ? "Promocje deweloperów" : "Promocja";
    }
};

export const getPromotionMetaDataTypeName = (type: PromotionType): string => {
    switch (type) {
        case PromotionType.PROMOTION:
            return "promocje";
        case PromotionType.OPEN_DAYS:
            return "dni otwarte";
        case PromotionType.DISCOUNT:
            return "przeceny";
        case PromotionType.LAST_MINUTE:
            return "oferty last minute";
        case PromotionType.PRESALE:
            return "przedsprzedaże";
        case PromotionType.EXHIBITION:
            return "targi mieszkaniowe";
        case PromotionType.NO_CONTRIBUTION:
            return "bez wkładu własnego";
        default:
            return "";
    }
};

const promotionPlural = pluralize(["specjalną", "specjalne", "specjalnych"]);
const offerTypePlural = pluralize(["promocyjną", "promocyjne", "promocyjnych"]);
const opendaysPlural = pluralize(["dni otwartych", "dni otwartych", "dni otwartych"]);
const discountPlural = pluralize(["przeceny", "przeceny", "przeceny"]);
const lastMinutePlural = pluralize(["last minute", "last minute", "last minute"]);
const presalePlural = pluralize(["przedsprzedaży", "przedsprzedaży", "przedsprzedaży"]);
const exhibitionPlural = pluralize(["targów mieszkaniowych", "targów mieszkaniowych", "targów mieszkaniowych"]);

export const getPromotionTypePlural = (type: PromotionType, count: number): string => {
    const getTypePlural = (typeValue: string) => `${propertyOffer.accusative(count)} ${typeValue}`;

    switch (type) {
        case PromotionType.PROMOTION:
            return getTypePlural(offerTypePlural(count));
        case PromotionType.OPEN_DAYS:
            return getTypePlural(opendaysPlural(count));
        case PromotionType.DISCOUNT:
            return getTypePlural(discountPlural(count));
        case PromotionType.LAST_MINUTE:
            return getTypePlural(lastMinutePlural(count));
        case PromotionType.PRESALE:
            return getTypePlural(presalePlural(count));
        case PromotionType.EXHIBITION:
            return getTypePlural(exhibitionPlural(count));
        default:
            return getTypePlural(promotionPlural(count));
    }
};

export const promotionTypes = [
    {label: "Promocje", value: PromotionType.PROMOTION},
    {label: "Dni otwarte", value: PromotionType.OPEN_DAYS},
    {label: "Przeceny", value: PromotionType.DISCOUNT},
    {label: "Last minute", value: PromotionType.LAST_MINUTE},
    {label: "Przedsprzedaż", value: PromotionType.PRESALE},
    {label: "Bez wkładu własnego", value: PromotionType.NO_CONTRIBUTION}
];
import {pluralize} from "@pg-mono/string-utils";
import {propertyOffer} from "@pg-mono/string-utils";

export enum PromotionType {
    PROMOTION = 1,
    OPEN_DAYS = 2,
    DISCOUNT = 3,
    LAST_MINUTE = 4,
    PRESALE = 5,
    EXHIBITION = 6,
    NO_CONTRIBUTION = 7
}

export const getPromotionTypeName = (type: PromotionType, offerLongVersion?: boolean): string => {
    switch (type) {
        case PromotionType.OPEN_DAYS:
            return "Dni Otwarte";
        case PromotionType.DISCOUNT:
            return "Przecena";
        case PromotionType.LAST_MINUTE:
            return "Last minute";
        case PromotionType.PRESALE:
            return "Przedsprzedaż";
        case PromotionType.EXHIBITION:
            return "Targi Mieszkaniowe";
        case PromotionType.NO_CONTRIBUTION:
            return `Nieruchomość bez wkładu własnego`;
        default:
            //  Offer
            return offerLongVersion ? "Promocje deweloperów" : "Promocja";
    }
};

export const getPromotionMetaDataTypeName = (type: PromotionType): string => {
    switch (type) {
        case PromotionType.PROMOTION:
            return "promocje";
        case PromotionType.OPEN_DAYS:
            return "dni otwarte";
        case PromotionType.DISCOUNT:
            return "przeceny";
        case PromotionType.LAST_MINUTE:
            return "oferty last minute";
        case PromotionType.PRESALE:
            return "przedsprzedaże";
        case PromotionType.EXHIBITION:
            return "targi mieszkaniowe";
        case PromotionType.NO_CONTRIBUTION:
            return "bez wkładu własnego";
        default:
            return "";
    }
};

const promotionPlural = pluralize(["specjalną", "specjalne", "specjalnych"]);
const offerTypePlural = pluralize(["promocyjną", "promocyjne", "promocyjnych"]);
const opendaysPlural = pluralize(["dni otwartych", "dni otwartych", "dni otwartych"]);
const discountPlural = pluralize(["przeceny", "przeceny", "przeceny"]);
const lastMinutePlural = pluralize(["last minute", "last minute", "last minute"]);
const presalePlural = pluralize(["przedsprzedaży", "przedsprzedaży", "przedsprzedaży"]);
const exhibitionPlural = pluralize(["targów mieszkaniowych", "targów mieszkaniowych", "targów mieszkaniowych"]);

export const getPromotionTypePlural = (type: PromotionType, count: number): string => {
    const getTypePlural = (typeValue: string) => `${propertyOffer.accusative(count)} ${typeValue}`;

    switch (type) {
        case PromotionType.PROMOTION:
            return getTypePlural(offerTypePlural(count));
        case PromotionType.OPEN_DAYS:
            return getTypePlural(opendaysPlural(count));
        case PromotionType.DISCOUNT:
            return getTypePlural(discountPlural(count));
        case PromotionType.LAST_MINUTE:
            return getTypePlural(lastMinutePlural(count));
        case PromotionType.PRESALE:
            return getTypePlural(presalePlural(count));
        case PromotionType.EXHIBITION:
            return getTypePlural(exhibitionPlural(count));
        default:
            return getTypePlural(promotionPlural(count));
    }
};

export const promotionTypes = [
    {label: "Promocje", value: PromotionType.PROMOTION},
    {label: "Dni otwarte", value: PromotionType.OPEN_DAYS},
    {label: "Przeceny", value: PromotionType.DISCOUNT},
    {label: "Last minute", value: PromotionType.LAST_MINUTE},
    {label: "Przedsprzedaż", value: PromotionType.PRESALE},
    {label: "Bez wkładu własnego", value: PromotionType.NO_CONTRIBUTION}
];
